<!--客户管理 - 第三方供货关系管理 - 供应商品-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="margin-top: 20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-button size="medium" type="primary" @click="filtrate()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="getAllProduct">一键同步产品</el-button>
        <el-button size="medium" type="primary" plain @click="exportAllProduct">导出供应产品</el-button>
        <el-button size="medium" @click="openExportIn">导入配送产品</el-button>
        <el-button size="medium" @click="openExportOut">批量解除供应产品</el-button>
        <el-button size="medium" @click="openAdd">新增配送关系</el-button>
        <el-button size="medium" @click="delReleation">解除供应</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top: 20px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="产品供应日期" v-if="priceMode == 2">
            <template slot-scope="scope">
              <span>{{ scope.row.P2_START_DAY + ' ~ ' + scope.row.P2_END_DAY }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当期结算扣点" prop="CURRENT_DP" v-if="beMaster != 2"></el-table-column>
          <el-table-column label="下期结算扣点" prop="NEXT_DP" v-if="beMaster != 2"></el-table-column>
          <el-table-column label="下期生效时间" prop="NEXT_EFFECTIVE_DATE" v-if="beMaster != 2"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="openEdit(scope.row)" type="text" v-if="beMaster != 2">修改</el-button>
              <el-button @click="currentRowDelReleation(scope.row)" type="text">解除供应</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
      <!-- 新增模态框 -->
      <el-dialog title="新增供应关系" center :visible.sync="addReleationFormVisible" width="440px"
        :close-on-click-modal="false">
        <el-form size="small" ref="addReleationForm" :model="addReleationForm" :label-width="formLableWidth">
          <el-form-item style="width: 95%">
            <el-switch v-model="showFlag" active-text="按产品名新增" inactive-text="按产品编码新增" @change="changeSwitch($event)">
            </el-switch>
          </el-form-item>
          <el-form-item label="产品：" v-show="showFlag">
            <el-select filterable v-model="addReleationForm.PRODUCT_CODE" placeholder="请选择" clearable
              style="width: 95%">
              <el-option v-for="item in productList" :label="item.PRODUCT_NAME" :value="item.PRODUCT_CODE + ''"
                :key="item.PRODUCT_CODE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品编码：" v-show="!showFlag">
            <el-input v-model="addReleationForm.PRODUCT_CODE" placeholder="请输入产品编码" clearable
              style="width: 95%"></el-input>
          </el-form-item>
          <el-form-item label="产品供应日期：" v-if="priceMode == 2">
            <el-date-picker v-model="addReleationForm.START_END" align="right" type="daterange" placeholder="选择日期范围"
              value-format="yyyy-MM-dd" style="width: 95%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="当期结算扣点：" v-if="beMaster != 2">
            <el-input v-model="addReleationForm.CURRENT_DP" style="width:95%"></el-input>
          </el-form-item>
          <el-form-item label="下期结算扣点：" v-if="beMaster != 2">
            <el-input v-model="addReleationForm.NEXT_DP" style="width:95%"></el-input>
          </el-form-item>
          <el-form-item label="下期生效时间：" v-if="beMaster != 2">
            <el-date-picker v-model="addReleationForm.NEXT_EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('addReleationForm')">取 消</el-button>
          <el-button size="small" @click="submitAdd('addReleationForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改供货类型 -->
      <el-dialog title="修改供应关系" center :visible.sync="editReleationFormVisible" width="400px"
        :close-on-click-modal="false">
        <el-form size="small" ref="editReleationForm" :model="editReleationForm" :label-width="formLableWidth">
          <el-form-item label="产品名称">
            <span>{{ editReleationForm.PRODUCT_NAME }}</span>
          </el-form-item>
          <el-form-item label="单位">
            <span>{{ editReleationForm.TYPE_UNIT }}</span>
          </el-form-item>
          <el-form-item label="当期结算扣点：" v-if="beMaster != 2">
            <el-input v-model="editReleationForm.CURRENT_DP" style="width:95%"></el-input>
          </el-form-item>
          <el-form-item label="下期结算扣点：" v-if="beMaster != 2">
            <el-input v-model="editReleationForm.NEXT_DP" style="width:95%"></el-input>
          </el-form-item>
          <el-form-item label="下期生效时间：" v-if="beMaster != 2">
            <el-date-picker v-model="editReleationForm.NEXT_EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('editReleationForm')">取 消</el-button>
          <el-button size="small" @click="submitEdit('editReleationForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 批量导入产品 -->
      <el-dialog title="导入供应产品" center :visible.sync="exportInFormVisible" width="400px" :close-on-click-modal="false">
        <el-form size="small" ref="exportInForm" :model="exportInForm" :label-width="formLableWidth">
          <el-form-item label="上传文件">
            <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
              :name="exportInForm.file" multiple :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <span @click="downLoadTemp" style="color:#409EFF">点此下载导入模板</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('exportInForm')">取 消</el-button>
          <el-button size="small" @click="submitExportIn('exportInForm')" :loading="loading1">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 批量解除匹配 -->
      <el-dialog title="解除产品供应" center :visible.sync="exportOutFormVisible" width="400px" :close-on-click-modal="false">
        <el-form size="small" ref="exportOutForm" :model="exportOutForm" :label-width="formLableWidth">
          <el-form-item label="上传文件">
            <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
              :name="exportOutForm.file" multiple :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <span @click="downLoadOutTemp" style="color:#409EFF">点此下载导入模板</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('exportOutForm')">取 消</el-button>
          <el-button size="small" @click="submitExportOut('exportOutForm')" :loading="loading1">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import {
  getproductReleationFun, addAllProductReleationFun, delProductReleationFun, getCanMatchProduct, editProductReleationFun, exportInProductFun, exportOutProductFun, exportAllProductFun,
} from 'api/customerManage';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      showFlag: true,
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      searchForm: {},
      points: [],
      supplierList: [],
      addReleationForm: {},
      addReleationFormVisible: false,
      editReleationFormVisible: false,
      editReleationForm: {},
      showMaster: ['副配送方', '主配送方'],
      formLableWidth: '120px',
      productList: [],
      exportInFormVisible: false,
      exportInForm: {
        file: 'tmp',
      },
      fileList: [],
      url: '',
      loading1: false,
      exportOutFormVisible: false,
      exportOutForm: {
        file: 'tmp',
      },
      checkedArray: [],
      beMaster: sessionStorage.getItem('BE_MASTER'),
      priceMode: sessionStorage.getItem('PRICE_MODE'),
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    changeSwitch($event) {},
    filtrate() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      if (!validation.产品编码验证(this.searchForm.PRODUCT_CODE)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      getproductReleationFun(params).then((result) => {
        if (result[1].list.length !== 0) {
          this.tableData = result[1].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    getAllProduct() {
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
      };
      addAllProductReleationFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd() {
      this.queryProduct();
      this.addReleationFormVisible = true;
    },
    submitAdd() {
      if (!this.addReleationForm.PRODUCT_CODE) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
      if (!this.showFlag) {
        if (!validation.产品编码验证(this.addReleationForm.PRODUCT_CODE)) {
          this.$message.show({ text: '请输入正确产品编码', type: 'warning' });
          return false;
        }
      }
      if (!this.check('addReleationForm')) {
        return false;
      }
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
        PRODUCT_CODE: this.addReleationForm.PRODUCT_CODE,
        PRICE_MODE: this.priceMode,
      };
      if (this.beMaster != 2) {
        params.NEXT_EFFECTIVE_DATE = this.addReleationForm.NEXT_EFFECTIVE_DATE;
        params.CURRENT_DP = this.addReleationForm.CURRENT_DP;
        params.NEXT_DP = this.addReleationForm.NEXT_DP;
      }
      if (this.priceMode == 2) {
        if (this.addReleationForm.START_END && this.addReleationForm.START_END[0]) {
          [params.P2_START_DAY, params.P2_END_DAY] = [...this.addReleationForm.START_END];
        } else {
          this.$message.show({ text: '请选择产品供应日期', type: 'warning' });
          return false;
        }
      }
      editProductReleationFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.addReleationFormVisible = false;
        this.queryData();
        this.addReleationForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editReleationFormVisible = true;
      this.editReleationForm = row;
    },
    submitEdit() {
      if (!this.editReleationForm.PRODUCT_CODE) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
      if (!this.check('editReleationForm')) {
        return false;
      }
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
        PRODUCT_CODE: this.editReleationForm.PRODUCT_CODE,
        NEXT_EFFECTIVE_DATE: this.editReleationForm.NEXT_EFFECTIVE_DATE,
        CURRENT_DP: this.editReleationForm.CURRENT_DP,
        NEXT_DP: this.editReleationForm.NEXT_DP,
        PRICE_MODE: this.priceMode,
        P2_START_DAY: this.editReleationForm.P2_START_DAY,
        P2_END_DAY: this.editReleationForm.P2_END_DAY,
      };
      editProductReleationFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editReleationFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => ({ ID: item.ID }));
    },
    delReleation() {
      this.$confirm('确认解除产品供货关系吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const submitArr = [];
        this.checkedArray.map((item) => {
          submitArr.push(item.ID);
        });
        const params = {
          RELEATION_IDS: submitArr,
        };
        delProductReleationFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', message: '已取消删除' });
      });
    },


    currentRowDelReleation(row) {
      this.$confirm('确认解除产品供货关系吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          RELEATION_IDS: [row.ID],
        };
        delProductReleationFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', message: '已取消删除' });
      });
    },


    queryProduct() {
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
      };
      getCanMatchProduct(params).then((result) => {
        if (result.length !== 0) {
          this.productList = result;
        } else {
          this.productList = [];
        }
      });
    },
    close() {
      this.editReleationFormVisible = false;
      this.addReleationFormVisible = false;
      this.exportInFormVisible = false;
      this.exportOutFormVisible = false;
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    downLoadTemp() {
      const url = 'https://service.linkda.com.cn/file/templates/';
      // fileNameList[价格模式][配送方类型]
      const fileNameList = [
        [],
        ['addtpproductdbtemp.xlsx', 'addtpproductdbtemp.xlsx', 'DSSupplierImportShippedProductsTemplate.xlsx'],
        ['addtpproductdbtempPM2.xlsx', 'addtpproductdbtempPM2.xlsx', 'DSSupplierImportShippedProductsTemplatePM2.xlsx'],
      ];
      window.location.href = url + fileNameList[this.priceMode][this.beMaster];
    },
    downLoadOutTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/deletetpproductdbtemp.xlsx';
    },
    openExportIn() {
      this.exportInFormVisible = true;
    },
    openExportOut() {
      this.exportOutFormVisible = true;
    },
    submitExportIn() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      // 执行代码
      const params = {
        FILE_NAME: this.url,
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
        PRICE_MODE: this.priceMode,
      };
      this.loading1 = true;
      exportInProductFun(params).then((result) => {
        if (result[0].FILE_PATH) {
          this.$message.show({ text: '部分导入失败，详情请查看文件', type: 'success' });
          this.loading1 = false;
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
          this.exportInFormVisible = false;
          this.loading1 = false;
          this.queryData();
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
      });
    },
    submitExportOut() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      // 执行代码
      const params = {
        FILE_NAME: this.url,
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
      };
      this.loading1 = true;
      exportOutProductFun(params).then((result) => {
        this.$message.show({ text: '导入成功', type: 'success' });
        this.exportOutFormVisible = false;
        this.loading1 = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
      });
    },
    exportAllProduct() {
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('SUPPLIER_ID'),
        PROJECT_ID: sessionStorage.getItem('PROJECT_ID'),
        PRICE_MODE: this.priceMode,
      };
      exportAllProductFun(params).then((result) => {
        if (result[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
      });
    },
    check(formName) {
      if (this.beMaster != 2) {
        if (
          !this.$refs[formName].model.CURRENT_DP || !validation.第三方扣点验证(this.$refs[formName].model.CURRENT_DP)
          || !this.$refs[formName].model.NEXT_DP || !validation.第三方扣点验证(this.$refs[formName].model.NEXT_DP)
          || !this.$refs[formName].model.NEXT_EFFECTIVE_DATE
        ) {
          this.$message.show({ text: '请正确填写扣点及生效日期，扣点须大于等于0小于100且至多两位小数', type: 'warning' });
          return false;
        }
      }
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/releationDetail.vue